/*
 * P Cart Discount — ô nhập mã giảm giá trong giỏ + cart drawer.
 *
 * Cơ chế (đã kiểm chứng trên polomanor.vn 2026-08-06):
 *   - Áp mã : GET /discount/<code>?redirect=/cart.js  → Shopify set cookie rồi trả thẳng cart JSON.
 *   - Đọc lại: cart.discount_codes[] (có cờ `applicable`) + cart_level_discount_applications[].
 *   - Gỡ mã : POST /cart/update.js {discount: ''}. (GET /discount/ rỗng trả 404 — không dùng được.)
 *
 * BẪY của Shopify: nhập mã SAI sẽ đẩy mã hợp lệ đang áp ra khỏi giỏ. Nên trước khi
 * áp mã mới ta nhớ lại mã hợp lệ hiện có, nếu mã mới bị từ chối thì áp lại mã cũ.
 *
 * Markup do snippets/p-cart-discount.liquid render. Vì cart drawer dựng lại DOM
 * từ <template id="template-cart">, mọi sự kiện đều uỷ quyền ở document và
 * render() luôn quét lại toàn bộ [data-p-discount] đang có trên trang.
 */
(function () {
  'use strict';
  if (window.__pCartDiscountInit) return;
  window.__pCartDiscountInit = true;

  var CFG = (window.PPromoConfig && window.PPromoConfig.discount) || {};
  var ENABLED = CFG.enabled !== false;
  var SUGGESTIONS = CFG.suggestions || [];
  var WARN_COMBINE = !!CFG.warnCombine;

  var _busy = false;
  var _removalSupported = true;
  var _lastMsg = null; // { type: 'error'|'ok'|'warn', text: string }

  function P() {
    return window.PPromo || null;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(cents) {
    var p = P();
    if (p) return p.money(cents);
    return Math.round((Number(cents) || 0) / 100).toLocaleString('vi-VN') + 'đ';
  }

  function containers() {
    return document.querySelectorAll('[data-p-discount]');
  }

  /* ------------------------------------------------------------------ *
   * Gọi Shopify
   * ------------------------------------------------------------------ */

  // Trả về cart JSON sau khi Shopify xử lý mã.
  function applyCode(code) {
    var url = '/discount/' + encodeURIComponent(code) + '?redirect=/cart.js';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () {
        // Store không cho redirect sang /cart.js → đọc giỏ theo cách thường
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); });
      });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function clearCode() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (r) {
        if (!r.ok) _removalSupported = false;
        return r.json();
      })
      .catch(function () {
        _removalSupported = false;
        return fetchCart();
      });
  }

  function syncTheme(cart) {
    var p = P();
    if (p && cart) p.setCart(cart);
    // Bắt theme vẽ lại tổng tiền + danh sách discount
    try {
      if (window.scaCart && window.scaCart.refresh) window.scaCart.refresh();
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ *
   * Render
   * ------------------------------------------------------------------ */

  function appliedCodes(cart) {
    if (!cart) return [];
    var codes = cart.discount_codes || [];
    var apps = cart.cart_level_discount_applications || [];

    return codes.filter(function (c) { return c.applicable !== false; }).map(function (c) {
      var amount = 0;
      for (var i = 0; i < apps.length; i++) {
        var a = apps[i];
        var title = a.title || (a.discount_application && a.discount_application.title);
        if (title && String(title).toUpperCase() === String(c.code).toUpperCase()) {
          amount = a.total_allocated_amount || 0;
          break;
        }
      }
      return { code: c.code, amount: amount };
    });
  }

  function rejectedCode(cart) {
    if (!cart || !cart.discount_codes) return null;
    for (var i = 0; i < cart.discount_codes.length; i++) {
      if (cart.discount_codes[i].applicable === false) return cart.discount_codes[i].code;
    }
    return null;
  }

  // Chip chỉ là "điều khiển" (mã + nút gỡ). Số tiền giảm để phần Tóm tắt đơn
  // hàng của theme hiển thị — in ở cả hai chỗ sẽ thành trùng lặp.
  function chipHTML(item) {
    return (
      '<li class="p-chip p-chip--muted p-discount__chip">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">' +
          '<path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '<span class="p-discount__chip-code">' + esc(item.code) + '</span>' +
        (_removalSupported
          ? '<button type="button" class="p-chip__x" data-p-discount-remove="' + esc(item.code) + '" aria-label="Gỡ mã ' + esc(item.code) + '">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
                '<path d="M18 6L6 18M6 6l12 12" stroke-linecap="round"/>' +
              '</svg>' +
            '</button>'
          : '') +
      '</li>'
    );
  }

  function suggestHTML(applied) {
    if (!SUGGESTIONS.length) return '';
    var have = {};
    applied.forEach(function (a) { have[String(a.code).toUpperCase()] = true; });
    var left = SUGGESTIONS.filter(function (c) { return !have[String(c).toUpperCase()]; });
    if (!left.length) return '';

    return (
      '<span class="p-discount__suggest-label">Mã đang có:</span>' +
      left.map(function (c) {
        return '<button type="button" class="p-chip p-chip--muted p-discount__suggest-btn" data-p-discount-fill="' + esc(c) + '">' + esc(c) + '</button>';
      }).join('')
    );
  }

  function render(cart) {
    var boxes = containers();
    if (!boxes.length) return;

    var applied = appliedCodes(cart);
    var chipsHTML = applied.map(chipHTML).join('');
    var sHTML = suggestHTML(applied);

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];

      if (!ENABLED) { box.hidden = true; continue; }
      box.hidden = false;

      var chips = box.querySelector('[data-p-discount-chips]');
      if (chips) {
        chips.innerHTML = chipsHTML;
        chips.hidden = !chipsHTML;
      }

      var suggest = box.querySelector('[data-p-discount-suggest]');
      if (suggest) {
        suggest.innerHTML = sHTML;
        suggest.hidden = !sHTML;
      }

      var msg = box.querySelector('[data-p-discount-msg]');
      if (msg) {
        if (_lastMsg) {
          msg.textContent = _lastMsg.text;
          msg.className = 'p-discount__msg p-discount__msg--' + _lastMsg.type;
          msg.hidden = false;
        } else {
          msg.textContent = '';
          msg.hidden = true;
        }
      }

      var btn = box.querySelector('[data-p-discount-submit]');
      if (btn) {
        btn.disabled = _busy;
        btn.classList.toggle('is-loading', _busy);
      }
    }
  }

  /* ------------------------------------------------------------------ *
   * Đánh dấu dòng quà tặng trong giỏ
   * ------------------------------------------------------------------ */

  function markGiftLines() {
    var p = P();
    var cart = p ? p.cartSync() : null;
    if (!cart || !cart.items) return;

    var giftKeys = {};
    var hasGift = false;
    cart.items.forEach(function (it) {
      if (p && p.isGiftLine(it)) { giftKeys[it.key] = true; hasGift = true; }
    });
    if (!hasGift) return;

    var lines = document.querySelectorAll('cart-item, .cart-item');
    for (var i = 0; i < lines.length; i++) {
      var el = lines[i];
      var key = el.getAttribute('key') || el.getAttribute('data-key') || el.getAttribute('item-key');
      if (key && giftKeys[key]) el.classList.add('p-gift-line');
    }
  }

  /* ------------------------------------------------------------------ *
   * Hành vi
   * ------------------------------------------------------------------ */

  function submitFrom(box) {
    if (_busy) return;
    var input = box.querySelector('[data-p-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      _lastMsg = { type: 'error', text: 'Nhập mã giảm giá trước đã.' };
      render(P() ? P().cartSync() : null);
      return;
    }

    _busy = true;
    _lastMsg = null;
    render(P() ? P().cartSync() : null);

    // Mã hợp lệ đang áp — cần khôi phục nếu mã mới bị Shopify từ chối.
    fetchCart().then(function (before) {
      var previous = appliedCodes(before)[0] || null;

      return applyCode(code).then(function (cart) {
        var ok = appliedCodes(cart).some(function (a) {
          return String(a.code).toUpperCase() === code.toUpperCase();
        });

        if (ok) {
          input.value = '';
          setOpen(box, false); // áp xong thì gập lại, chip mã hiện bên dưới
          // Không báo "Đã áp dụng mã X" — chip mã đã nói rõ rồi.
          // Chỉ giữ lại lưu ý về cộng gộp nếu store đang bật cảnh báo.
          _lastMsg = WARN_COMBINE
            ? { type: 'warn', text: 'Lưu ý: mã giảm giá có thể không cộng gộp với khuyến mãi tự động đang chạy.' }
            : null;
          return cart;
        }

        _lastMsg = { type: 'error', text: 'Mã ' + code.toUpperCase() + ' không hợp lệ hoặc không dùng được cho giỏ này.' };

        // Shopify đã đá mã cũ ra khi nhận mã sai → áp lại mã cũ.
        if (previous) {
          return applyCode(previous.code).then(function (restored) {
            _lastMsg.text += ' Mã ' + previous.code.toUpperCase() + ' vẫn được giữ.';
            return restored;
          });
        }

        // Không có mã cũ → dọn mã rác để giỏ không kẹt mã không hợp lệ.
        return clearCode();
      });
    }).then(function (cart) {
      _busy = false;
      syncTheme(cart);
      render(cart);
    }).catch(function () {
      _busy = false;
      _lastMsg = { type: 'error', text: 'Không kết nối được, thử lại giúp mình nhé.' };
      render(P() ? P().cartSync() : null);
    });
  }

  function removeCode(code) {
    if (_busy) return;
    _busy = true;
    _lastMsg = null;
    render(P() ? P().cartSync() : null);

    clearCode().then(function (cart) {
      _busy = false;
      var still = appliedCodes(cart).some(function (a) {
        return String(a.code).toUpperCase() === String(code).toUpperCase();
      });
      if (still) {
        _removalSupported = false;
        _lastMsg = { type: 'error', text: 'Không gỡ được mã ở đây — bạn có thể đổi mã ở bước thanh toán.' };
      } else {
        // Gỡ xong chip biến mất là đủ tín hiệu, không cần câu thông báo.
        _lastMsg = null;
      }
      syncTheme(cart);
      render(cart);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-p-discount-form]') : null;
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-p-discount]');
    if (box) submitFrom(box);
  });

  // Người dùng gõ lại -> bỏ thông báo cũ cho đỡ rối.
  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.hasAttribute) return;
    if (!e.target.hasAttribute('data-p-discount-input')) return;
    if (!_lastMsg) return;
    _lastMsg = null;
    render(P() ? P().cartSync() : null);
  });

  function setOpen(box, open) {
    var toggle = box.querySelector('[data-p-discount-toggle]');
    var panel = box.querySelector('[data-p-discount-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    box.classList.toggle('is-open', open);
    if (open) {
      var inp = panel.querySelector('[data-p-discount-input]');
      if (inp) inp.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var tg = e.target.closest('[data-p-discount-toggle]');
    if (tg) {
      e.preventDefault();
      var tbox = tg.closest('[data-p-discount]');
      if (tbox) setOpen(tbox, tg.getAttribute('aria-expanded') !== 'true');
      return;
    }

    var rm = e.target.closest('[data-p-discount-remove]');
    if (rm) {
      e.preventDefault();
      removeCode(rm.getAttribute('data-p-discount-remove'));
      return;
    }

    var fill = e.target.closest('[data-p-discount-fill]');
    if (fill) {
      e.preventDefault();
      var box = fill.closest('[data-p-discount]');
      var input = box && box.querySelector('[data-p-discount-input]');
      if (input) {
        input.value = fill.getAttribute('data-p-discount-fill');
        submitFrom(box);
      }
    }
  });

  /* ------------------------------------------------------------------ *
   * Khởi động
   * ------------------------------------------------------------------ */

  function refresh() {
    var p = P();
    if (!p) { render(null); return; }
    p.getCart().then(function (cart) {
      render(cart);
      markGiftLines();
    });
  }

  function start() {
    if (!ENABLED) { render(null); return; }

    if (window.PPromo) {
      // KHÔNG xoá _lastMsg ở đây: syncTheme() bắn onChange ngay sau khi áp mã,
      // xoá ở đây sẽ nuốt mất thông báo thành công/lỗi vừa đặt.
      window.PPromo.onChange(refresh);
      refresh();
      return;
    }

    // p-promo-core.js nạp defer — chờ nó bằng setTimeout (không dùng rAF).
    var tries = 40;
    (function wait() {
      if (window.PPromo) { start(); return; }
      if (tries-- <= 0) { render(null); return; }
      setTimeout(wait, 150);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
